<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :close-on-click-modal="false" :lock-scroll="false" :before-close="closeDialog">
    <div v-loading.fullscreen="loading">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <!-- <el-form-item class="login_form_item" prop="mobile">
          <el-input class="login_ipt" v-model="ruleForm.mobile" placeholder="Please enter your phone number" @input="setInput()"></el-input>
        </el-form-item> -->
        <el-form-item class="login_form_item" prop="mobile">
          <el-input class="login_ipt" v-model="ruleForm.mobile" @input="setInput()">
            <template  slot="prepend">
              <span>{{ruleForm.nationCode}}</span>
              <el-select class="login_flag"  v-model="ruleForm.nationCode" placeholder="Please enter your phone number" @change='changeLocation'>
                <el-option v-for="(item,index) in nationList" :key="index" :label="item.NationCode" :value="item.NationCode">
                  <div class="locationOption">
                    <img :src="item.IconUrl">
                    <span>{{item.EnName}}</span>
                  </div>
                </el-option>
              </el-select>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item class="login_form_item" prop="password">
          <el-input class="login_ipt" v-model="ruleForm.password" :type="flagType" maxlength='20' placeholder="Please enter your password" @input="setInput()">
            <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" @click="getFlag()" />
          </el-input>
        </el-form-item>
        <el-button class="login_btn" :disabled='disabled' type="primary" @click="submitForm('ruleForm')">Sign In</el-button>
        <!-- <div style="margin-top:20px;">
          <el-checkbox v-model='checked' class="top" label="Remember me" name="type">
            <div class="userText">By signing in, you agree to the <router-link :to="{path:'/useragreement'}">Terms of Service</router-link> <br>and <router-link :to="{path:'/privacyagreement'}">Privacy Policy</router-link>
            </div>
          </el-checkbox>
        </div> -->
        <div class="tips">
          <div>
            <span @click="godialog('forgot','login')">Forgot password?</span>
            <!-- <el-divider direction="vertical"></el-divider>
            <span @click="godialog('register','login')">Sign up</span> -->
          </div>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import { login,countries } from "@/api/public";
export default {
  name: 'login',
  components: {},
  data() {
    return {
      loading: false,
      dislogType: this.$enumInfo.dislogType,
      flagType: 'password',
      flag: false,
      checked: true,
      disabled: true,
      dialogClass: 'user',
      nationList:'',
      ruleForm: {
        mobile: '',
        password: '',
        nationCode:'+49'
      },
      rules: {
        mobile: [
          { required: true, message: 'Please enter a valid phone number', trigger: 'blur' },
        ],
        password: [
          { required: true, message: 'Please enter the correct password', trigger: 'blur' },
        ]
      },
    }
  },
  props: {
    title: String,
    domVisible: Boolean,
  },
  created() {},
  mounted() {
    let that = this
    that.getNationList()
    window.addEventListener('keydown', function(e) {
      if (!that.disabled) {
        if (e.keyCode === 13) {
          that.submitForm('ruleForm')
        }
      }
    })
    //console.log(this.$interface.SignIn)
  },
  methods: {
    
    getNationList() {
      let that = this;
      this.$get(this.$interface.GetNationList).then(async res => {

        that.nationList =countries(res) 
      })
    },
    changeLocation(e) {
      let that = this
      that.nationList.map(res => {
        
        if (res.Code == e) {
          that.ruleForm.nationCode=res.NationCode
          //that.LocationIcon = res.IconUrl
        }
      })
    },
    // 点击快捷跳转 忘记密码 和 注册
    godialog(toval, val) {
      this.$emit('closeDialog', val, false)
      this.$emit('godialog', toval, true)
    },
    closeOther(val, bol) {
      this.dislogType[val] = bol
    },
    // 关闭弹框
    closeDialog(val) {
      this.$emit('closeDialog', 'login', false)
    },
    //密码切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password' //text为显示密码；password为隐藏密码
      console.log(this.flag, this.flagType)
    },
    // 判断input是否有值
    setInput() {
      if (this.ruleForm.mobile != '' && this.ruleForm.password != '') {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    // 登入
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.disabled = true
          
          let data = that.ruleForm
          var Nation = that.ruleForm.nationCode
            if (Nation.indexOf('+') > -1) {
              Nation = Nation.slice(1)
              data.nationCode=Nation
            }
          if (that.checked) {
            that.loading = true;
            that.$post(that.$interface.SignIn, data).then(res => {
              if (res.Result != 0) {
                login(res.Data)
                that.closeDialog()
              } else {
                that.disabled = false
                that.$message.error(res.Msg);
              }
              that.loading = false;
            }).catch({
            })
          } else {
            that.$message.error('Please agree to the terms');
            that.disabled = false
          }
          //login()
        }
      });
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/login.css";

/deep/ .login_flag input{
  width: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/login.vue